import React from 'react';
import { FormattedMessage } from 'react-intl';

import { RangeValue } from '@/features/brakes/hooks/useBrakesQueryParams';
import CriticalityFilter from '@/features/common/components/CriticalityFilter';
import RangeInputWithSlider from '@/features/common/components/RangeInputWithSlider';
import { Status } from '@/generated/GeneratedApiTypes';

interface BrakeLiningFiltersProps {
    minValue: number;
    maxValue: number;
    onRangeChange: (range: RangeValue) => void;
    criticalityStatus: Status[];
    onCriticalityChange: (status: Status[]) => void;
    isLoading: boolean;
}

const getCriticalityFilterOptions = (selectedItems: Status[]) => [
    {
        id: Status.DANGER,
        label: <FormattedMessage id="intl-msg:vehicle_diagnostics.filters.criticality.critical" />,
        icon: <span className="rioglyph rioglyph-error-sign text-size-16 text-color-danger" />,
        selected: selectedItems.length === 0 || selectedItems.includes(Status.DANGER),
    },
    {
        id: Status.WARNING,
        label: <FormattedMessage id="intl-msg:vehicle_diagnostics.filters.criticality.warning" />,
        icon: <span className="rioglyph rioglyph-warning-sign text-size-16 text-color-warning" />,
        selected: selectedItems.length === 0 || selectedItems.includes(Status.WARNING),
    },
    {
        id: Status.NORMAL,
        label: <FormattedMessage id="intl-msg:vehicle_diagnostics.filters.criticality.ok" />,
        icon: <span className="rioglyph rioglyph-ok text-size-16 text-normal" />,
        selected: selectedItems.length === 0 || selectedItems.includes(Status.NORMAL),
    },
];

const BrakeLiningFilters = ({
    minValue,
    maxValue,
    onRangeChange,
    criticalityStatus,
    onCriticalityChange,
    isLoading,
}: BrakeLiningFiltersProps) => {
    return (
        <div className="display-flex flex-row gap-20 align-items-end">
            <RangeInputWithSlider
                max={100}
                min={0}
                range={{ from: minValue, to: maxValue }}
                title="intl-msg:vehicle-diagnostics.maintenance.table.brakes.filter.title"
                onRangeChange={onRangeChange}
                unit={'%'}
            />
            <CriticalityFilter
                isLoading={isLoading}
                title={<FormattedMessage id="intl-msg:vehicle_diagnostics.filters.criticality.title" />}
                placeholder=""
                filterOptions={getCriticalityFilterOptions(criticalityStatus)}
                onSelect={onCriticalityChange}
            />
        </div>
    );
};

export default BrakeLiningFilters;
